import { render, staticRenderFns } from "./base-serve-table.vue?vue&type=template&id=2b64ca10&scoped=true&"
import script from "./base-serve-table.vue?vue&type=script&lang=js&"
export * from "./base-serve-table.vue?vue&type=script&lang=js&"
import style0 from "./base-serve-table.vue?vue&type=style&index=0&id=2b64ca10&scoped=true&lang=scss&"
import style1 from "./base-serve-table.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b64ca10",
  null
  
)

export default component.exports